<template>
    <div class="mb-4" >
        <div class="d-flex align-items-center mb-2 label_box">
            <label class="mb-0">{{label}}</label>
            
            <div class="ms-2" @click="handleSvgClick" v-if="['cyor', 'her_size', 'his_size','size'].includes(type)">
                <SvgHeaderSvg  :type="'ask'" />
            </div>

            <ModalChainLength v-if="type === 'cyop'" />
            <ModalBackType v-if="type === 'cyoe'" />
            
        </div>
        <div class="drop_block" v-click-outside="()=> showOptions = false" :class="{'invalid': mode}">
            <div class="current_active" @click="showOptions = !showOptions">
                <div class="d-flex align-items-center mr-2 select_text">
                    <SvgMetalSvg v-if="currentActive && currentActive.icon != null" :type="currentActive.icon" />
                    <span v-if="!currentActive" class="ms-2"> select</span>
                    <span v-else class="ms-2">{{currentActive.label}}</span>
                </div>
                <div class="arr_box">
                    <SvgHeaderSvg v-show="!showOptions" :type="'down'" />
                    <SvgHeaderSvg v-show="showOptions" :type="'up'" />
                </div>
            </div>
            <div v-show="showOptions">
                <ul class="p-0">
                    <li v-for="list in data"
                        :key="list.value + list.icon"
                        @click="toggleOption(list.value)"
                        :class="{'active': list.selected === 1, 'disabled': list.visibility === 0}"
                    >
                        <SvgMetalSvg v-if="list.icon != null" :type="list.icon" />
                        <span class="ms-2">{{list.label}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="error_boxx" v-if="mode">{{ mode }}</div>
       
        <!-- <p class="mb-0 pt-1" v-if="type === 'size'">* Eternity rings cannot be resized. <router-link :to="localePath('/customer-service/ring-resizing')">Read more</router-link></p> -->
        <!-- <p class="mb-0 pt-1" v-if="flag === 'cyor_resize'">* This ring cannot be resized. <router-link :to="localePath('/customer-service/ring-resizing')">Read more</router-link></p> -->
    </div>
</template>

<script setup>

    import { ClickOutsideDirective as vClickOutside } from '@/directives/ClickOutsideDirective';
    
    const props = defineProps(['data', 'label', 'type', 'mode'])
    const localePath = useLocalePath()

    const emit = defineEmits(['toggleOption','onSvgClick'])

    const showOptions= ref(false)
    const handleSvgClick = ()=>{
        if(emit('onSvgClick')){
            emit('onSvgClick')
        }
    }
    const currentActive = computed(()=> {
                return props.data.find((item) => item.selected === 1)
            })
    

            const toggleOption = (value)=>{
                props.data.filter((item) => {
                    if(item.value === value){
                        item.selected = 1
                    }else{
                        item.selected = 0
                    }
                })
                showOptions.value = false
                emit('toggleOption', props.type, value)
               
            }
            // directives: {
            //     clickOutside: ClickOutsideDirective,
            // },
    
</script>

<style scoped>
.label_box a .svg-head {
    margin: 0 0 -2px 9px;
}
p{
    font-size: 12px;
    font-weight: 600;
}
p a{
    color: var(--green);
}
.arr_box svg.svg-head {
    height: 16px;
}
.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}
.label_box {
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}
.label_box div{
    color: rgb(159, 158, 158);
    cursor: pointer;
}
.drop_block{
    position: relative;
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
}


.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}
ul {
    border: 1px solid #ccc;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 220px !important;
    overflow: auto;
}
ul li{
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}
ul li.active {
    background: rgba(204,204,204,0.36863);
}
span{
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    text-transform: capitalize;
}


ul li.disabled {
    pointer-events: none;
    opacity: 0.5;
}


@media(max-width:767px){
    label{
        font-size: 14px;
    }
}


</style>
